export const MODEL_COST_TIER = {
  CHEAP: 'cheap',
  NORMAL: 'normal',
  EXPENSIVE: 'expensive',
} as const;

export const MODEL_COST_TIERS = [
  MODEL_COST_TIER.CHEAP,
  MODEL_COST_TIER.NORMAL,
  MODEL_COST_TIER.EXPENSIVE,
] as const;

export type ModelCostTier = (typeof MODEL_COST_TIERS)[number];

export const DEFAULT_MODEL_COST_TIER: ModelCostTier = MODEL_COST_TIER.NORMAL;

export const MODEL_COST_TIER_LABELS: Record<ModelCostTier, string> = {
  [MODEL_COST_TIER.CHEAP]: 'Cheap',
  [MODEL_COST_TIER.NORMAL]: 'Normal',
  [MODEL_COST_TIER.EXPENSIVE]: 'Expensive',
};
